/**
 * The minimum largest safe size for a file chunk unit in bytes
 */ export const SafeFileUploadChunkSize = 327680; // 320kB
export const MaxFileUploadApiRetries = 3;
export const MaxFileUploadApiFileSize = 104857600; // 100MB
